/**
 * En puesta en marcha (`me.operation === 'SETUP'`, lo mismo que decide `/setup`) primero se termina eso: el
 * Administrador solo tiene el asistente y las pantallas de configuración que abre; cualquier otra ruta, también escrita
 * a mano, vuelve al asistente. Quien no administra ve solo que la entidad está en preparación, sin menú.
 */
export const SETUP_PATHS = ['/puesta-en-marcha', '/configuracion'];

/** Qué se muestra en `pathname`: la app, la vista en preparación (sin menú) o la redirección al asistente. */
export function setupGate(me: { operation?: string } | null, admin: boolean, pathname: string): 'app' | 'preparing' | { redirect: string } {
  if (me?.operation !== 'SETUP') return 'app';
  if (!admin) return 'preparing';
  return SETUP_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`)) ? 'app' : { redirect: '/puesta-en-marcha' };
}
